import gql from 'graphql-tag';

export default class UserFragments {
  static user = gql`
    fragment userFragment on User {
      id
      firstName
      lastName
      fullName
      title
      mobile
      email
      thumbUrl
      imageScale
      imageTranslateX
      imageTranslateY
    }
  `;
}
